import React from 'react';
import { PrivacyInformationsWrapper } from './PrivacyInformations.style';

interface Props {
  text: string | JSX.Element | JSX.Element[] | null | undefined;
}

export const PrivacyInformations: React.FunctionComponent<Props> = ({ text }: Props) => {
  return <PrivacyInformationsWrapper>
    {text}
  </PrivacyInformationsWrapper>;
};
